import { useEffect, useRef } from "react";

/**
 * Kit (formerly ConvertKit) embedded newsletter form.
 * Drops the Kit script into the wrapper div on mount — Kit's JS then
 * renders the form HTML inside this container.
 *
 * Each instance loads its own copy of the script; the browser caches
 * after the first fetch, so additional instances render instantly.
 */
export default function KitForm({
  uid = "22f56ddfff",
  testId = "kit-form",
}) {
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Prevent double-injection if React strict-mode mounts twice
    if (el.querySelector(`script[data-uid="${uid}"]`)) return;

    const script = document.createElement("script");
    script.async = true;
    script.setAttribute("data-uid", uid);
    script.src = `https://scale-architect-labs.kit.com/${uid}/index.js`;
    el.appendChild(script);
  }, [uid]);

  return (
    <div
      ref={containerRef}
      data-testid={testId}
      className="kit-form-wrapper w-full"
    />
  );
}
